<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <span>{{ getTranslations.visitor_sign_up_1_single_country_activate_free_trial }}</span>
          </div>
          <div class="progressbar-container" v-if="hasRegSteps()">
            <ol :class="['progress ', show2stepsOnlyOrNoneInForgot() ? 'twoStepList' : '' ]">
              <li class="is-active" data-step="1">
              </li>
              <li class="" data-step="2">
              </li>
              <li data-step="3" class="progress__last" v-if="!show2stepsOnlyOrNoneInForgot()">
              </li>
            </ol>
          </div>
          <div class="signup-form">
            <div class="form-help">
              <p>{{ getTranslations.visitor_sign_up_1_single_country_info_msg_enter_msisdn }}</p>
              <img v-if="imageUsed" class="form-help__icon" :src="imageUsed" @error="imageErrorHandler" alt="">
            </div>
            <div class="operators_selection_wrap" v-if="multiOperatorInfo.multiOperatorEnabled && showOperators()">
              <p>{{ getTranslations.visitor_sign_up_1_single_country_my_operator }} </p>
              <div class="operators_radio">
                <label v-for="(operator, index) in multiOperatorInfo.multiOperatorKeys" class="operators_radio operators_radio_inline" :key="index" v-if="multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage[index]">
                  <img class="operators_icon" :src="getOperatorImage(index)" :alt="getOperatorDisplayName(index)">
                  <input type="radio" name="operator" :value="operator" v-model="operatorPicked" @click="check();getOrdinalByOperator(operator);">
                  <span></span>
                </label>
              </div>
              <div class="operators_error_msg" v-if="!operatorPicked && btnSubmitted"> <span class="form-group__feedback">{{ getTranslations.visitor_sign_up_1_single_country_select_operator }}</span></div>
            </div>
            <form action="">
              <div class="form-group form-group--mobile"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input v-if="hideForExternalRedirectionProjects()"
                       type="text" class="form-group__textfield phone_input" autocomplete="one-time-code"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_1_single_country_placeholder"
                       @keyup="check" v-model="user.msisdn"/>
                <span v-show="getMessage(message) && user.msisdn" class="form-group__feedback">{{ getMessage(message) }}</span>
              </div>
              <p v-if="showDisclaimerNotice()">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_free_for') }}</p>
              <input v-if="!validationForOneTimeSubscription"
                     type="submit"
                     :value="getTranslations.visitor_sign_up_1_single_country_submit_button_continue"
                     :class="['btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitAction">
              <input v-if="validationForOneTimeSubscription"
                     type="submit"
                     :value="getTranslations.visitor_sign_up_1_single_placeholder_daily_subscription"
                     :class="['one_time btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitActionForSubscriptionButtons(true)">
              <input v-if="validationForOneTimeSubscription"
                     type="submit"
                     :value="getTranslations.visitor_sign_up_1_single_placeholder_one_time_subscription"
                     :class="['one_time btn btn--medium btn--main', ( (hasErrors || waitForResponse)? 'deactivated' : '')]"
                     @click.prevent="onSubmitActionForSubscriptionButtons(false)">
              <div class="form-footer">
                {{ getTranslations.visitor_sign_up_1_single_country_already_have_account }}
                <router-link :to="'login'">{{ getTranslations.visitor_sign_up_1_single_country_login }}</router-link>
              </div>
              <div class="form-group form-group--mobile">
                <span class="form-group__feedback reg_notice" v-if="showDisclaimer()">* {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer') }}</span>
                <ul class="alter_flow_list form-group__feedback reg_notice">
                  <li v-for="(key, index) in disclaimers"
                      v-if="getTranslations[key]"
                      :key="index">
                    {{ getTranslations[key] }}
                  </li>
                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/flow/SimplifyRegistration';

export default {
  name: 'sign-up-1-single-country',
  components: {simplifyRegistration},
  mixins: [RegistrationFlowMixin],
  data() {
    return {
      btnSubmitted: false,
      operatorPicked: '',
      user: {
        msisdn: '',
      },
      message: '',
      hasErrors: false,
      defaultImagePath: '/ext/banners/RegistrationDefault.jpg',
      imageUsed: '',
      waitForResponse: false,
      validationForOneTimeSubscription: null,
      showSimpleRegistrationModal: false,
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3'],
    };
  },
  created() {
    const numOfVisibleOperators = (this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.filter(item => item)).length;
    if (numOfVisibleOperators === 1) {
      const position = this.multiOperatorInfo.multiOperatorDisplayedNamesInRegisterPage.indexOf(true);
      const operator = this.multiOperatorInfo.multiOperatorKeys[position];
      this.storeOperator(operator);
      this.operatorPicked = operator;
    }
    if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.OOREDOO_ALGERIA.name) {
      if (document.getElementById('db_response')) {
        document.getElementById('korek_response').remove();
        document.getElementById('db_response').remove();
      }
      sessionStorage.setItem('isRun', 'true');
    }
    if (this.$route.query.errorMessage) this.message = this.getTranslatedErrorMessage(this.$route.query.errorMessage);
    if (this.message) {
      this.user.msisdn = this.$route.query.errorMsisdn || '';
      this.hasErrors = true;
    } else if (this.getIntegrationConfig.config) {
      this.user.msisdn = this.$route.query.heMsisdn || '';
    }
    this.setCorrelationId({ value: this.$route.query.cid || '' });
    this.imageUsed = this.banner ? `/ext/banners/${this.banner}.jpg` : this.defaultImagePath;
    this.validationForOneTimeSubscription = this.getIntegrationConfig.integrationKey === this.availableIntegrations.OMANTEL_OMAN.name;
  },
  methods: {
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDisplayPrice',
      'setDefaultDailySubButtonEnabled'
    ]),
    ...mapActions('common', [
      'storeOperator',
    ]),
    hideForExternalRedirectionProjects() {
      if (this.getIntegrationConfig.integrationKey === 'mtn_rsa_he') {
        sessionStorage.setItem('operator', this.operatorPicked);
        this.user.msisdn = '1234567890';
        return false;
      }
      return true;
    },
    showOperators() {
      const activeIntegration = this.getIntegrationConfig.config;
      return !activeIntegration || !activeIntegration.affectsMultiOperator;
    },
    showDisclaimerNotice() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_free_for');
    },
    showDisclaimer() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.operatorPicked;
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_1_single_country_disclaimer');
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    getTranslatedErrorMessage(errorMessage) {
      switch (errorMessage) {
      case 'MSISDN_INVALID': return 'visitor_sign_up_invalid_msisdn_msg';
      case 'ALREADY_REGISTERED': return 'visitor_sign_up_msisdn_already_registered';
      case 'MSISDN_NOT_EXIST': return 'visitor_sign_up_msisdn_not_exists';
      case 'MSISDN_BLACKLISTED': return 'visitor_sign_up_msisdn_blacklisted';
      case 'BLOCKED_USER': return 'visitor_forgot_password_warning_msd_max_attempts';
      case 'CAMPAIGN_CLOSED': return 'visitor_sign_up_campaign_closed';
      case 'SERVER_ERROR': return 'home_profile_profile_edit_server_unvailable';
      case 'POLICY_BREACH_SUB_NOT_ALLOWED': return 'visitor_sign_up_policy_breach';
      default: return 'visitor_sign_up_warning_third_party_error';
      }
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    imageErrorHandler() {
      this.imageUsed = this.defaultImagePath;
    },
    check() {
      let validMsisdnRegex = /^[0-9]{0,20}$/;
      if (this.conversionForArabicFields) validMsisdnRegex = /^[٠١٢٣٤٥٦٧٨٩0-9]{0,20}$/;
      const validMsisdn = this.user.msisdn.match(validMsisdnRegex);
      if (!validMsisdn) {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    mapErrorMessages(resMessage) {
      if (resMessage === 'MSISDN_INVALID') {
        this.message = 'visitor_sign_up_invalid_msisdn_msg';
      } else if (resMessage === 'ALREADY_REGISTERED') {
        this.message = 'visitor_sign_up_msisdn_already_registered';
      } else if (resMessage === 'MSISDN_NOT_EXIST') {
        this.message = 'visitor_sign_up_msisdn_not_exists';
      } else if (resMessage === 'MSISDN_BLACKLISTED') {
        this.message = 'visitor_sign_up_msisdn_blacklisted';
      } else if (resMessage === 'BLOCKED_USER') {
        this.message = 'visitor_forgot_password_warning_msd_max_attempts';
      } else if (resMessage === 'CAMPAIGN_CLOSED') {
        this.message = 'visitor_sign_up_campaign_closed';
      } else if (resMessage === 'SERVER_ERROR') {
        this.message = 'home_profile_profile_edit_server_unvailable';
      } else if ((resMessage === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resMessage === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resMessage === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
        this.message = 'visitor_sign_up_warning_third_party_error';
      } else if (resMessage === 'POLICY_BREACH_SUB_NOT_ALLOWED') {
        this.message = 'visitor_sign_up_policy_breach';
      }
    },
    onSubmitActionForSubscriptionButtons(isDailySubscription) {
      this.setDefaultDailySubButtonEnabled(isDailySubscription);
      this.btnSubmitted = true;
      if (isDailySubscription) {
        this.checkButton(isDailySubscription);
      } else {
        const showModal = (!this.getIntegrationByName()) ? false : this.getIntegrationByName().value.showRegistrationModal;
        if (showModal) {
          this.showSimpleRegistrationModal = true;
        } else {
          this.checkButton(isDailySubscription);
        }
      }
    },
    onSubmitAction() {
      this.btnSubmitted = true;
      if (!this.multiOperatorInfo.multiOperatorEnabled || (this.multiOperatorInfo.multiOperatorEnabled && this.operatorPicked)) {
        this.checkButton();
      } else {
        this.hasErrors = true;
      }
    },
    checkButton(isDailySubscription) {
      this.message = '';
      this.waitForResponse = true;
      let appropriateRequestPinStep = this.getAlternateRequestPinAction(isDailySubscription); // integration specific
      if (!appropriateRequestPinStep) {
        appropriateRequestPinStep = this.getNextRegistrationStepForRequestPin(); // flow specific (default)
      }
      appropriateRequestPinStep.call(this);
    },
  },
  computed: {
    ...mapState('common', [
      'banner',
      'multiOperatorInfo',
      'conversionForArabicFields',
      'availableIntegrations'
    ]),
    ...mapGetters('common', [
      'getActiveIntegrationConfig',
      'getIntegrationConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp1SingleCountry.vue